import {
  AUTOSCALING_ELIGIBILITY_PARAM_KEY,
  AUTOSCALING_STATE_PARAM_KEY,
} from '~/shared/utils/autoscalingFilterUtils';

export const PROCESSED_FILTERS_PARAM_KEY = 'processed_filters';

export function clearAllFilterSearchParams(
  params: URLSearchParams,
  apiFilterKey: string,
  processedFiltersKey: string = PROCESSED_FILTERS_PARAM_KEY
): void {
  params.delete(apiFilterKey);
  params.delete(AUTOSCALING_STATE_PARAM_KEY);
  params.delete(AUTOSCALING_ELIGIBILITY_PARAM_KEY);
  params.delete(processedFiltersKey);
}
